import { useQuery } from '@tanstack/react-query';

import type { ApiError } from '@/types/api.types';

import { lookUpInvite } from '../api/staffApi';
import type { InviteDetails } from '../types';

const inviteKey = (token: string) => ['invite', token] as const;

export function useInviteDetails(token: string | null) {
  const query = useQuery<InviteDetails, ApiError>({
    queryKey: inviteKey(token ?? ''),
    queryFn: () => lookUpInvite(token!),
    enabled: !!token,
    retry: false,
  });

  return {
    invite: query.data ?? null,
    isLoading: query.isLoading,
    error: query.error ?? null,
  };
}
